module.exports = __webpack_public_path__ + "img/AvatarRuby.7e0c477d.png";